<template>
  <transition name="fade-scale">
    <div class="ui-picker" v-show="value">
      <NfPicker :dataList="dataList" ref="areaNfPicker" />
      <div class="btn-wrapper">
        <button class="btn btn-cancel" @click="handleCancel">取消</button>
        <button class="btn btn-confirm" @click="handleConfirm">确定</button>
      </div>
    </div>
  </transition>
</template>

<script>
import NfPicker from "../NfPicker"

export default {
  name: "uiPicker",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    handleCancel() {
      this.$emit("input", false)
      this.$emit("cancel")
    },
    handleGetSelArr() {
      return this.$refs.areaNfPicker.selArr.slice(0)
    },
    handleGetSelItem() {
      const key = `areaNfPicker`
      return this.$refs[key].selItem.slice(0)
    },
    handleConfirm() {
      const selArr = this.handleGetSelArr()
      const selItem = this.handleGetSelItem()
      this.$emit("confirm", { selArr, selItem })
      this.$emit("input", false)
    }
  },
  components: {
    NfPicker
  }
}
</script>

<style lang="scss" scoped>
.ui-picker {
  background: #ffffff;
  position: absolute;
  top: calc(100%);
  left: 0;
  width: 100%;
  transform-origin: 50% 0;
  .btn-wrapper {
    border-top: 1px solid #dddddd;
    display: flex;
    .btn {
      background: #ffffff;
      outline: none;
      border: none;
      border-right: 1px solid #dddddd;
      height: 0.96rem;
      flex: 1;
      &:last-child {
        border-right: none;
      }
      &.btn-cancel {
        font-family: PingFangSC-Regular;
        font-size: 0.34rem;
        color: #389bee;
        letter-spacing: 0;
        text-align: center;
      }
      &:active {
        opacity: 0.7;
      }
      &.btn-confirm {
        font-family: PingFangSC-Regular;
        font-size: 0.34rem;
        color: #389bee;
        letter-spacing: 0;
        text-align: center;
      }
    }
  }
}
.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scaleY(0);
}
.fade-scale-enter-to,
.fade-scale-leave {
  opacity: 1;
  transform: scaleY(1);
}
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.3s ease-in-out;
}
</style>
